import { NIGHTS_GET_QUERY_PARAMS } from "../../../store/nights/getter-types";

export const goToStep = {
  methods: {
    goToStep(step) { // step = :step param
      this.$router.push({
        name: 'nights-wizard',
        params: { step },
        query: this.$store.getters[NIGHTS_GET_QUERY_PARAMS],
      }).catch(() => {});
    }
  },
}
